import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TopMenu from "../../TopMenu";
import TableDocument from "../../TableDocument";
import FilterModal from "../../../../Components/Common/FilterModal";
import { get } from "../../../../utils/api";
import { useUser } from "../../../../context/AuthContext";

const API_BASE = "/scope3/useOfSoldProducts";

const UseOfSoldProductsDocuments = () => {
  const { user } = useUser();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const columnWidth = user?.companyAdmin
    ? "10% 12% 14% 14% 14% 14% 14% 8%"
    : "11% 15% 15% 15% 15% 15% 8%";

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("road");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [filter, setFilter] = useState({
    productCategory: [],
    productName: [],
  });

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
  };

  const handleToggle = (option, nextUrl) => {
    setSelectedOption(option);
    setUrl(nextUrl);
  };

  let filtersToApply = {};

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        facilityList: selectedFacility.join(","),
        limit: 10,
        search: searchQuery,
      }).toString();

      const response = await get(
        `${API_BASE}/documents?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      );
      setData(response.data.data);
      setTotalPages(response.data.totalPages);
      setPage(response.data.currentPage);
    } catch (error) {
      console.error("Error fetching use of sold products documents:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, fromDate, toDate, selectedFacility, searchQuery]);

  // const fetchFilter = async () => {
  //   try {
  //     const response = await get(`${API_BASE}/filter`);
  //     const { productCategory, productName } = response.data?.data || {};
  //     setFilter({
  //       productCategory: productCategory || [],
  //       productName: productName || [],
  //     });
  //   } catch (error) {
  //     console.error("Error fetching use of sold products document filters:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchFilter();
  // }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const heading = [
    { title: "Date", key: "createdAt" },
    user?.companyAdmin
      ? { title: "Facility", key: "facilityName" }
      : null,
      { title: "Date of Sale", key: "dateOfSale" },
    { title: "Product Name", key: "productName" },
    { title: "Product ID / SKU", key: "productIdOrSku" },
    { title: "Unit of Product Sold", key: "unitOfProductSold" },
    { title: "Recyclable Components (%)", key: "replacementParts" }
  ].filter(Boolean);

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    { title: "Date of Sale", type: "date", key: "dateOfSale", value: [] },
    {
      title: "Product Category",
      type: "option",
      key: "productCategory",
      value: filter.productCategory || [],
    },
    {
      title: "Product Name",
      type: "option",
      key: "productName",
      value: filter.productName || [],
    },
  ];

  const toggleData = [];

  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      <TopMenu
        {...{
          setDrawerFilterOpen: setIsFilterModalOpen,
          selectedMonth,
          setSelectedMonth,
          selectedYear,
          setSelectedYear,
          selectedOption,
          handleToggle,
          filterApplied: isFiltersApplied,
          toggleData,
          fromDate,
          setFromDate,
          toDate,
          setToDate,
          selectedFacility,
          setSelectedFacility,
          searchQuery,
          setSearchQuery,
          fetchData,
        }}
        heading="Use of Sold Products"
      />

      <TableDocument
        data={data}
        totalPages={totalPages}
        page={page}
        handleChangePage={handleChangePage}
        headers={heading}
        columnWidth={columnWidth}
      />

      {/* <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      /> */}
    </MainDashboardLayout>
  );
};

export default UseOfSoldProductsDocuments;
